import axios from 'axios';

import { env } from 'config';
import { P2PProviderPayoutWebhook, PaginatedData, QueryParams } from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/p2p-providers-payout-webhooks`; // TODO: common path with payin

export const p2pProvidersPayoutWebhooksApi = {
  getForOrder:
    (providerOrderId: string) =>
    async (
      params?: Partial<QueryParams>,
    ): Promise<P2PProviderPayoutWebhook[]> =>
      (
        await apiUtils.getWithQueryParams(
          `${url}/order/${providerOrderId}`,
          params,
        )
      ).data,

  getAllPaginated: async (
    params?: Partial<QueryParams>,
  ): Promise<PaginatedData<P2PProviderPayoutWebhook>> =>
    (await apiUtils.getWithQueryParams(`${url}/paginated`, params)).data,

  retry: async (id: string): Promise<P2PProviderPayoutWebhook> =>
    (await axios.post(`${url}/${id}/retry`)).data,
};
